/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.DATE_TIME = function () {

    this.resourceKey = 'Survey.Sidebar.DateTime';
    this.jsonType = 'DATE_TIME';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);
};